import { createFileRoute } from "@tanstack/react-router";
import { ModuleGuard } from "@/components/auth/ModuleGuard";
import EmailsPage from "@/pages/EmailsPage";

export const Route = createFileRoute("/_app/emails")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <ModuleGuard module="contacts">
      <EmailsPage />
    </ModuleGuard>
  );
}
